import React, { FC } from "react"
import CardTable from "../../../ui/table/CardTable"

type State51BatchIdsProps = {
  userAdminPermissions?: string
}

const State51BatchIds: FC<State51BatchIdsProps> = (props) => {
  return (
    <div className="flex justify-center">
      <CardTable
        userAdminPermissions={props.userAdminPermissions}
        title={`State 51 Batch IDs`}
        urlBase="state_51_batch_ids"
        dataName="Batch ID"
        dataKey="batchId"
        itemName="Batch ID"
        iconPath="/music-library.svg"
      />
    </div>
  )
}

export default State51BatchIds
